import { render, staticRenderFns } from "./LocalInfoHome.vue?vue&type=template&id=779dc554&scoped=true&"
import script from "./LocalInfoHome.vue?vue&type=script&lang=js&"
export * from "./LocalInfoHome.vue?vue&type=script&lang=js&"
import style0 from "./LocalInfoHome.vue?vue&type=style&index=0&id=779dc554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779dc554",
  null
  
)

export default component.exports